import {gql} from '@apollo/client';

export const GET_SIMULATOR_CONFIG = gql`
  query GetSimulator {
    getSimulator {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithSimulator {
        data {
          id
          active
          free {
            pricing {
              yearly {
                XOF
                XAF
                USD
                EUR
              }
              monthly {
                XOF
                XAF
                USD
                EUR
              }
            }
            duration
            baseWalletValue
            maxWalletValue
            resetLimit
            resetFee {
              XOF
              XAF
              USD
              EUR
            }
            fundingFee {
              XOF
              XAF
              USD
              EUR
            }
            fundingValue
          }
          premium {
            pricing {
              yearly {
                XOF
                XAF
                USD
                EUR
              }
              monthly {
                XOF
                XAF
                USD
                EUR
              }
            }
            duration
            baseWalletValue
            maxWalletValue
            resetLimit
            resetFee {
              XOF
              XAF
              USD
              EUR
            }
            fundingFee {
              XOF
              XAF
              USD
              EUR
            }
            fundingValue
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const UPDATE_SIMULATOR = gql`
  mutation UpdateSimulator($input: UpdateSimulatorInput!) {
    updateSimulator(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithSimulator {
        data {
          id
        }
      }
    }
  }
`;

export const GET_SIMULATOR_SUBSCRIPTIONS = gql`
  query GetSimulatorSubscriptions($input: SimulatorSubscriptionFilterInput) {
    getSimulatorSubscriptions(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithSimulatorSubscriptions {
        pagination {
          limit
          total
        }
        data {
          id
          active
          currency
          amount
          planType
          subscriptionType
          cycle
          resetCount
          lastResetAt
          startedAt
          expiresAt
          channel
          createdAt
          updatedAt
          user {
            id
            firstName
            lastName
            email
            imageUrl
          }
        }
      }
    }
  }
`;

export const GET_SIMULATOR_RESTART_PURCHASES = gql`
  query GetSimulatorRestartPurchases(
    $input: SimulatorRestartPurchasesFilterInput
  ) {
    getSimulatorRestartPurchases(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithSimulatorRestartPurchases {
        pagination {
          total
        }
        data {
          id
          currency
          status
          amount
          quantity
          createdAt
          updatedAt
          user {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;

export const GET_SIMULATOR_RESTART_PURCHASES_STATS = gql`
  query GetSimulatorRestartStatistics($filters: OverviewFilters) {
    getSimulatorRestartStatistics(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithOverviewResponse {
        message
        data {
          ... on SimulatorRestartStatisticsData {
            totalUsers
            totalRestarts
            revenueByCurrency {
              totalRestarts
              totalAmount
              symbol
              currency
            }
          }
        }
      }
    }
  }
`;
